import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { HttpLink } from '@apollo/client/link/http';

export type HttpLinkOptions = Readonly<{
	uri: string;
	headers?: Readonly<Record<string, string>>;
	fetch?: typeof fetch;
}>;

export type HttpLinks = Readonly<{ single: HttpLink; batch: BatchHttpLink }>;

export function getHttpLinks({ uri, headers, fetch }: HttpLinkOptions): HttpLinks {
	const config = {
		uri,
		credentials: 'same-origin',
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'X-Requested-With': 'http-link',
			...headers,
		},
		fetch,
		fetchOptions: {
			method: 'POST',
		},
		includeExtensions: true,
	};
	return {
		single: new HttpLink(config),
		batch: new BatchHttpLink(config),
	};
}
